import {
  GlobalState,
  GlobalStore
} from "../../chunk-XVNHYOIL.js";
import "../../chunk-QL34RJ4Y.js";
import "../../chunk-3HMZ6FL6.js";
import "../../chunk-A6K3NLMV.js";
import "../../chunk-DGUM43GV.js";

// src/lib/jotai/atom-with-lazy-hydration.ts
import { atom } from "jotai";
var UNHYDRATED = /* @__PURE__ */ Symbol("unhydrated");
function atomWithLazyHydration(key, initialValue, storage) {
  const overrideAtom = atom(UNHYDRATED);
  overrideAtom.onMount = (setOverride) => {
    setOverride(storage.getItem(key, initialValue));
    return storage.subscribe?.(key, setOverride, initialValue);
  };
  return atom(
    (get) => {
      const override = get(overrideAtom);
      return override === UNHYDRATED ? storage.getItem(key, initialValue) : override;
    },
    (get, set, update) => {
      const override = get(overrideAtom);
      const prev = override === UNHYDRATED ? storage.getItem(key, initialValue) : override;
      const next = typeof update === "function" ? update(prev) : update;
      set(overrideAtom, next);
      storage.setItem(key, next);
    }
  );
}

// src/lib/jotai/atom-with-state.ts
import { atomWithStorage } from "jotai/utils";
function globalAtomState(initial) {
  return {
    getItem(key, initialValue) {
      const value = GlobalState.get(key, initialValue);
      if (value === void 0) {
        return initialValue;
      }
      return value;
    },
    setItem(key, newValue) {
      GlobalState.set(key, newValue);
    },
    removeItem(key) {
      GlobalState.delete(key);
    },
    subscribe(key, callback) {
      const onUpdate = () => {
        callback(GlobalState.get(key, initial));
      };
      GlobalState.on(key, callback);
      GlobalState.on("renderer:ready", onUpdate);
      return () => {
        GlobalState.off(key, callback);
        GlobalState.off("renderer:ready", onUpdate);
      };
    }
  };
}
function atomWithGlobalState(key, initialValue, options) {
  const storage = globalAtomState(initialValue);
  if (options?.hydrateOnFirstRead) {
    return atomWithLazyHydration(key, initialValue, storage);
  }
  return atomWithStorage(key, initialValue, storage);
}

// src/lib/jotai/atom-with-store.ts
import { atomWithStorage as atomWithStorage2 } from "jotai/utils";
function globalAtomStore(storeName, initial) {
  return {
    getItem(key, initialValue) {
      const value = GlobalStore.access(storeName).get(key, initialValue);
      if (value === void 0) {
        return initialValue;
      }
      return value;
    },
    setItem(key, newValue) {
      GlobalStore.access(storeName).set(key, newValue);
    },
    removeItem(key) {
      GlobalStore.access(storeName).delete(key);
    },
    subscribe(key, callback) {
      const onUpdate = () => {
        callback(GlobalStore.access(storeName).get(key, initial));
      };
      GlobalStore.access(storeName).on(key, callback);
      GlobalStore.access(storeName).on("renderer:ready", onUpdate);
      return () => {
        GlobalStore.access(storeName).off(key, callback);
        GlobalStore.access(storeName).off("renderer:ready", onUpdate);
      };
    }
  };
}
function atomWithGlobalStore(storeName, key, initialValue) {
  return atomWithStorage2(key, initialValue, globalAtomStore(storeName, initialValue));
}
export {
  atomWithGlobalState,
  atomWithGlobalStore,
  atomWithLazyHydration
};
//# sourceMappingURL=index.js.map